/* eslint-disable no-underscore-dangle */
// 9fbef606107a605d69c0edbcd8029e5d
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, initialize, submit, isInvalid, isPristine } from 'redux-form';
import SpcSelector from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import { getUserLastName, getUserName } from '../../../../account/User/container/User.selectors';
import CheckoutSelector, {
  isGuest,
  getPickupValues,
  getPickupAltValues,
  isPickupAlt,
  getLoginV2FlowEnabled,
  getSmsPhoneCountryCodePickup,
} from '../../../Checkout/container/Checkout.selector';
import { getContactFormValuesFromSS } from '../../molecules/ContactForm/ContactForm.util';
import Pickup from '../../molecules/Pickup';
import {
  activateSpcSection,
  addEditStoreDetails,
  updateSectionState,
  clickedOutsideShipping,
} from '../SinglePageCheckout.actions';
import { SPC_SECTION, SPC_BUTTON } from '../SinglePageCheckout.constants';
import {
  clickedOutsideShippingFlag,
  getOrderProducts,
  getPickupFormData,
  getSinglePageCheckoutSectionState,
} from '../SinglePageCheckout.selector';
import BagPageSelector from '../../../BagPage/container/BagPage.selectors';
import { PICKUP_FORM_NAME } from './Pickup.constants';
import { openPickupModalWithValues } from '../../../../../common/organisms/PickupStoreModal/container/PickUpStoreModal.actions';
import {
  getIsBossEnabled,
  getIsInternationalPhoneNumber,
  getIsNewEddViewCheckout,
  getOrderTrackingEnhancementEnabled,
  getSMSUpdatesAPIOptimization,
  getSMSUpdatesSingleOptInEnabled,
} from '../../../../../../reduxStore/selectors/session.selectors';
import { getShippingFormValuesFromSS } from '../Shipping/Shipping.utils';
import {
  setPhoneCountryPickUp,
  setSMSUpdatesActn,
} from '../../../Checkout/container/Checkout.action';

const formName = PICKUP_FORM_NAME;

export const PickupContainer = (props) => {
  return <Pickup {...props} />;
};
const mapStateToProps = (state) => {
  const pickupFormInput = getFormValues(formName)(state);
  const savedAddress = CheckoutSelector.getShippingAddress(state);
  const pristine = isPristine(formName)(state);
  const invalid = isInvalid(formName)(state);
  const section = getSinglePageCheckoutSectionState()(state, SPC_SECTION.PICKUP);
  const contactData = getSinglePageCheckoutSectionState()(state, SPC_SECTION.CONTACT);
  const contactFormValuesFromSS = getContactFormValuesFromSS(contactData);
  const { emailAddress, phoneNumber } = { ...contactFormValuesFromSS };
  const updateItems = getOrderProducts(state);
  const userFirstName = getUserName(state);
  const userLastName = getUserLastName(state);
  const getShippingAddress = BagPageSelector.getCompleteShippingAddress(state);
  const isBossEnabled = getIsBossEnabled(state);
  const isLoginV2FlowEnabled = getLoginV2FlowEnabled(state);
  const contactPickupData = isLoginV2FlowEnabled
    ? getSinglePageCheckoutSectionState()(state, SPC_SECTION.SHIPPING)
    : getSinglePageCheckoutSectionState()(state, SPC_SECTION.PICKUP);
  const contactSectionValues = getSinglePageCheckoutSectionState()(state, SPC_SECTION.CONTACT);
  const contactPickupFormValuesFromSS = getShippingFormValuesFromSS(contactPickupData);
  const emailAddressFromSS = getContactFormValuesFromSS(contactSectionValues);
  const savedEmail = CheckoutSelector?.getVenmoUserEmail(state) || emailAddressFromSS?.emailAddress;
  return {
    formName,
    pickUpContactPerson: getPickupValues(state),
    pickUpAlternatePerson: getPickupAltValues(state),
    isHasPickUpAlternatePerson: isPickupAlt(state),
    userEmail: emailAddress,
    userPhone: phoneNumber,
    section,
    savedAddress,
    pickupFormInput,
    isGuestUser: isGuest(state),
    getPickupFormData: getPickupFormData(state),
    saveBtnLoadingStatus: getSinglePageCheckoutSectionState()(state, SPC_BUTTON.SAVE_PICKUP),
    pristine,
    invalid,
    orderProducts: updateItems._tail.array,
    userFirstName,
    userLastName,
    clickedOutsideShippingFlag: clickedOutsideShippingFlag(state),
    getShippingAddress,
    isBossEnabled,
    isNewEddViewCheckout: getIsNewEddViewCheckout(state),
    isSPC: SpcSelector.checkIsSinglePageCheckout(state),
    pickupReduxForm: CheckoutSelector.getPickupReduxFormValues(state),
    orderTrackingEnhancementEnabled: getOrderTrackingEnhancementEnabled(state),
    contactPickupFormValuesFromSS,
    contactSectionValues,
    smsSignUpLabels: CheckoutSelector.getSmsSignUpLabels(state),
    smsUpdatesAPIOptimization: getSMSUpdatesAPIOptimization(state),
    savedEmail,
    isSMSUpdatesSingleOptInEnabled: getSMSUpdatesSingleOptInEnabled(state),
    isInternationalPhoneNumberEnabled: getIsInternationalPhoneNumber(state),
    smsPhoneCountryCode: getSmsPhoneCountryCodePickup(state),
  };
};

export const mapDispatchToProps = (dispatch) => ({
  fillFormOnEdit: (payload) => dispatch(initialize(payload)),
  updateStoreDetails: (payload) => dispatch(addEditStoreDetails(payload)),
  updateSectionState: (payload) =>
    dispatch(updateSectionState({ id: SPC_SECTION.PICKUP, section: payload })),
  triggerFormSubmit: () => dispatch(submit(formName)),
  activateSpcSection: () => dispatch(activateSpcSection({ id: SPC_SECTION.PICKUP })),
  clickedOutsideShipping: (payload) => dispatch(clickedOutsideShipping(payload)),
  onPickUpOpenClick: (payload) => {
    dispatch(openPickupModalWithValues(payload));
  },
  setSMSUpdatesAction: (payload) => dispatch(setSMSUpdatesActn(payload)),
  setPhoneCountryAction: (payload) => dispatch(setPhoneCountryPickUp(payload)),
});

PickupContainer.propTypes = {
  section: PropTypes.shape({}).isRequired,
  addressFormLabels: PropTypes.shape({}).isRequired,
  fillFormOnEdit: PropTypes.func.isRequired,
  clickedOutsideShippingFlag: PropTypes.bool,
};

PickupContainer.defaultProps = {
  clickedOutsideShippingFlag: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(PickupContainer);
